module.exports = __webpack_public_path__ + "static/img/shared_briefcase_icon.524abca6.png";